
/**
 * Redirect hooks who will simulate "target='_blank'"
 */
 export const useRedirectTargetBlank = () => {
    return (uri: string) => {
        window.open(uri, '_blank');
    }
}
